import { render, staticRenderFns } from "./urlMix.vue?vue&type=template&id=36e7ef3c"
import script from "./urlMix.vue?vue&type=script&lang=js"
export * from "./urlMix.vue?vue&type=script&lang=js"
import style0 from "./urlMix.vue?vue&type=style&index=0&id=36e7ef3c&prod&lang=scss&scope=true"
import style1 from "./urlMix.vue?vue&type=style&index=1&id=36e7ef3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports